const PLATFORM_NAME = 'borrower-admin';

//Key es el nombre del resolver o mutation
export const SENTRY_GRAPHQL_FLOW_NAMES: any = {
  'login': {
    op: 'ui.flow.login',
    flowName: `${PLATFORM_NAME}.flow-login`
  },
  'CreateLoanDoc': {
    op: 'ui.flow.create-loan-doc',
    flowName: `${PLATFORM_NAME}.flow-create-loan-doc`
  }
}